export const BIND_DIRECTIVE_EVENT = 'bind_tooltip';
export const UNBIND_DIRECTIVE_EVENT = 'unbind_tooltip';
export const UPDATE_TOOLTIP_EVENT = 'update_tooltip';
